import React from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Locations from './components/Locations';
import FAQ from './components/FAQ';
import TestimonialBanner from './components/Testimonials';
import BannerSlider from './components/BannerSlider.js';
import ImageGallery from './components/ImageGallery';
import ClinicalExcellenceBanner from './components/ClinicalExcellenceBanner';
import Talks_Blogs from './components/Talks_Blogs';
import FixedImages from './components/FixedImages';

function App() {
  return (
    <>
    <Header />
    <FixedImages />
    <BannerSlider />
    <ImageGallery />
    <ClinicalExcellenceBanner />
    <Talks_Blogs />
    <TestimonialBanner />
    <FAQ />
    <Locations />
    <Footer />
    </>
  );
}

export default App;